<template>
    <div class="card">
        <div>
            <div class="row">
                <div class="col-lg-9 col-sm-8">
                    <div class="p-4">
                        <h5 class="text-primary">Your pricing is on demand</h5>
                        <p>
                            This means that Clients will have to ask you for prices of your posts every time they would like to collaborate.
                        </p>
                        <p>
                            By defining your prices you’ll:
                        </p>

                        <div class="text-muted">
                            <p class="mb-1">
                                <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                                {{ $t('Have higher percentage of signed agreements.') }}
                            </p>
                            <p class="mb-1">
                                <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                                {{ $t('Speed up negotiation process.') }}
                            </p>
                            <p class="mb-0">
                                <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                                {{ $t('Be presented to Clients when they filter by price.') }}
                            </p>
                        </div>

                        <p class="text-muted mt-2">
                            You can always switch back to on-demand pricing.
                        </p>

                        <div class="mt-4">
                            <button @click="switchToFixedPrices" class="btn btn-primary" :disabled="!hasAnyNetwork"> {{ $t('Switch to fixed prices') }} </button>
                            <div class="text-muted mt-1" v-if="!hasAnyNetwork">
                              First, you must connect at least one social network!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "noPricingCard",
        computed: {
            ...mapState('user', {
                user: (state) => state.user
            }),
            hasAnyNetwork() {
              let has = false;
              ['instagram', 'facebook', 'youtube', 'blog'].forEach(network => {
                if (this.user.social_network_accounts[network]) {
                  has = true;
                }
              })

              return has
            }
        },
        methods: {
            switchToFixedPrices () {
              this.$store.dispatch('user/switchToFixedPrices');
            }
        }
    }
</script>

<style scoped>

</style>
